phoneFormatter.$inject = ['$window'];

/* @ngInject */
function phoneFormatter($window) {
    // Usage:
    //
    // Creates:
    //
    var directive = {
        link: link,
        restrict: 'A',
        scope: {
            phoneFormatter: '='
        }
    };
    return directive;

    function link(scope, element, attrs) {
        scope.$watch('phoneFormatter', function (number) {
            var formatted = number;
            try {
                var format = (number.charAt(0) != "+") ? $window.intlTelInputUtils.numberFormat.NATIONAL : $window.intlTelInputUtils.numberFormat.INTERNATIONAL;
                formatted = $window.intlTelInputUtils.formatNumber(number, 'ar', format);
            } catch (e) {
            }

            element.html(formatted);
        });
    }
}

export default phoneFormatter;